import * as React from "react"
import { SessionExpiredModal } from "./SessionExpiredModal"
import { getSessionInfo } from "./Session"

export function SessionMonitor({ children }: { children: React.ReactNode }): React.JSX.Element {
    const [isSessionExpired, setIsSessionExpired] = React.useState(false)
    const [hadValidSession, setHadValidSession] = React.useState(false)

    React.useEffect(() => {
        void (async () => {
            const sessionInfo = await getSessionInfo()
            if (sessionInfo !== undefined) {
                setHadValidSession(true)
            }
        })()
    }, [])

    React.useEffect(() => {
        const handleSessionExpired = () => {
            if (hadValidSession) {
                setIsSessionExpired(true)
            }
        }

        window.addEventListener("session-expired", handleSessionExpired)

        return () => {
            window.removeEventListener("session-expired", handleSessionExpired)
        }
    }, [hadValidSession])

    return (
        <>
            {children}
            <SessionExpiredModal open={isSessionExpired} />
        </>
    )
}
